import React, { useEffect, useState } from "react";
import {showToast, TOAST_TYPE, showLoader, removeLoader} from "deskera-ui-library";
import { useDispatch, useSelector } from "react-redux";
import { fetchAISSummary, fetchSubmissionLogs, selectAISSummary, selectSubmissionLogs } from "../../../../../Redux/Slices/AISSubmissionSlice";
import Utility, { deepClone } from "../../../../../utility/Utility";
import MaskInputUtil from "../../../../../SharedComponents/MaskInput/MaskInputUtil";
import TenantManager from "../../../../../managers/TenantManager";
import { aisSummaryLogsColumnConfig, parseVisibleColumnConfig } from "../../../../configs/config";
import {TableManger, TABLES} from "../../../../../managers/TableManger"
import DataGridHolderPayroll from "../../../../common/DataGridHolderPayroll";
import { selectCPFAccounts } from "../../../../../Redux/Slices/EmployeeListSlice";
import AttachmentService from "../../../../../services/AttachmentService";
import { saveAs } from 'file-saver';
import { FILE_TYPE } from "../../../../../constants/Constant";

const IRASSubmissionLogs = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    /**Hooks */
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails)
    const [reload, setReload] = useState(false);
    const [employee, setEmployee] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(20);
    const [requestParameter, setRequestParameter] = useState(props?.data?.params);

    /**Selectors */
    const summaryLogs = useSelector(selectSubmissionLogs);
    const cpfDetails = useSelector(selectCPFAccounts)

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        if(props?.data?.isUpdateTrigerred) {
            loadAISSummaryLogs(props?.data?.params)
            setRequestParameter(props?.data?.params)
        }
    },[props])

    useEffect(() => {
        if(!Utility.isEmpty(summaryLogs)) {
            const { content, pageable, totalElements, totalPages } = summaryLogs;
            const functionConfig = getFucntionConfig()
            const rowData = aisSummaryLogsColumnConfig(
                content,
                functionConfig,
                cpfDetails
            );
            let columns = TableManger.getTableColumns(TABLES.PEOPLE_IRAS_AIS_SUBMISSION_LOGS);
            let employeeColumn = parseVisibleColumnConfig(columns);
            const passingData = {
                columnData: deepClone(employeeColumn),
                rowData,
                filter: [],
                originalData: rowData,
              };
            setEmployee(passingData);
            setTotalPageCount(parseInt(totalPages));
            setCurrentPage(parseInt(pageable.pageNumber));
            setTotalCount(parseInt(totalElements));
        }

    },[summaryLogs]);

    const loadAISSummaryLogs = async (config) => {
        try{
            const configDetail = {
                limit: config.limit,
                page: config.page,
                sort: config.sort,
                sortDir: config.sortDir,
                cpfAccountId: config.cpfAccountId,
                startDate: config.startDate,
                endDate: config.endDate
              };
            await dispatch(fetchSubmissionLogs(configDetail))
        }catch(err) {
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        }
    }

    const downloadInputFile = (data) => {
        download(data,'requestFilePath')
    }

    const downloadResponse = (data) => {
        download(data,'responseFilePath')
    }

    const getFucntionConfig = () => {
        let config = {
            "downloadInputFile" : downloadInputFile,
            "downloadResponse" : downloadResponse
        }
        return config;
    }

    const download = (log,path) => {

        if (log.rowData && log.rowData[path]) {
            showLoader("Downloading attachment... Please wait");
            AttachmentService.getPresignedURL(log.rowData[path]).then((response) => {
                AttachmentService.downloadFile(response).then((response) => {
                    removeLoader();
                    saveAs(response, getFilename(log.rowData[path]));
                }, (error) => {
                    removeLoader()
                })
            })
        } 
        
    }

    const getFilename = (url) => {
        let fileName = url.substring(url.indexOf("_") + 1, url.indexOf(".csv"));
        return `${fileName}.${FILE_TYPE.TXT}`;
    }

    return(
        <>
            <div className="column parent-width flex-1">
            <div className="column mt-l parent-width mb-s position-relative flex-1">
              <DataGridHolderPayroll
                tableName={TABLES.PEOPLE_IRAS_AIS_SUBMISSION_LOGS}
                displayTableName={""}
                allowColumnEdit={false}
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={false}
                allowFilter={false}
                allowColumnAdd={false}
                gridData={employee}
                onPaginationClick={(requestedPageNumber) => {
                  const config = {
                    page: requestedPageNumber,
                  };
                  loadAISSummaryLogs(config);
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={false}
                contextMenu={true}
                isMenuVisible={false}
                allowRowEdit={false}
                showContextEdit={false}
                isActionEnabled={true}
                // onDownloadAttachment={(data) => {
                //     downloadInputFile(data)
                // }}
              />
            </div>
          </div>
        </>

    )
}

export default IRASSubmissionLogs;